import React, { useState, useEffect } from 'react';
import { storage } from '@/utils/storage';

export const AutoLogoutTest: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [tokenExists, setTokenExists] = useState<boolean>(false);

  useEffect(() => {
    // Set a test token to monitor
    //storage.setLocal('auth_token', 'test-token-123');
    //console.log('Test token set with 2-minute expiry');

    const interval = setInterval(() => {
      const token = storage.getLocal('auth_token');
      setTokenExists(!!token);
      
      if (token) {
        // Calculate time left
        const tokenData = localStorage.getItem('auth_token');
        if (tokenData) {
          const parsed = JSON.parse(tokenData);
          const remaining = Math.max(0, parsed.expiry - Date.now());
          setTimeLeft(Math.ceil(remaining / 1000));
        }
      } else {
        setTimeLeft(0);
        console.log('Token expired - should trigger logout');
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const clearToken = () => {
    localStorage.removeItem('auth_token');
    setTokenExists(false);
    setTimeLeft(0);
  };

  return (
    <div>
      <button onClick={clearToken}>Clear Token</button>
      {tokenExists && <p>Time left: {timeLeft}s</p>}
    </div>
  );
};